import { Component, OnInit,TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { LetterRequestCustomer_Schedule_BehfaDevice_Interface } from 'src/app/Interface/LetterRequestCustomer_Schedule_BehfaDevice_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceGroupService } from 'src/app/Service/DeviceGroup/DeviceGroup.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-LetterRequestCustomerScheduleDeviceBehfa',
  templateUrl: './LetterRequestCustomerScheduleDeviceBehfa.component.html',
  styleUrls: ['./LetterRequestCustomerScheduleDeviceBehfa.component.scss']
})
export class LetterRequestCustomerScheduleDeviceBehfaComponent implements OnInit {

  Token: String = ""
  Procssing: boolean = false
  InProccessing: boolean = false
  page:number=0

  DataList_DeviceBehfa_Schedule:Array<LetterRequestCustomer_Schedule_BehfaDevice_Interface>=[]

  constructor(
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
    private DeviceGroup_Service:DeviceGroupService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');


    this.Nav_Service.CheckValidPage(this.Token, 1165).subscribe(
      data => {
        this.Read_First_Device_Group()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  ReadData_Device(StartSearchDate,EndSearchDate){
    this.Procssing=true

    this.LetterRequestCustomer_Service.GetLetterRequestCustomerScheduleDeviceBehfa(this.Token,
      this.Selected_DataList_DeviceBehfa.id,
      Number(this.First_Device_Group_Selected),
      Number(this.Second_Device_Group_Selected),
      StartSearchDate,
      EndSearchDate).subscribe(
      data=>{
        this.DataList_DeviceBehfa_Schedule=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#region  Device Behfa

  modalRef_DeviceBehfa: any;

  openModal_DeviceBehfa(template: TemplateRef<any>) {
    this.modalRef_DeviceBehfa = this.modalService.show(template);

  }

  DataList_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  Selected_DataList_DeviceBehfa:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface) {
    this.Selected_DataList_DeviceBehfa = item
    this.modalRef_DeviceBehfa.hide()
  }

  //#endregion

  //#region Device Group

  DataList_First_Device_Group:Array<General_Interface>=[]
  DataList_Second_Device_Group:Array<General_Interface>=[]

  First_Device_Group_Selected:string='0'
  Second_Device_Group_Selected:string='0'

  Read_First_Device_Group(){
    this.DeviceGroup_Service.GetDeviceGroup(this.Token,0).subscribe(
      data=>{
        this.DataList_First_Device_Group=data
      }
    )
  }

  Read_Second_Device_Group(){
    this.Second_Device_Group_Selected="0"
    this.DeviceGroup_Service.GetDeviceGroup(this.Token,Number(this.First_Device_Group_Selected)).subscribe(
      data=>{
        this.DataList_Second_Device_Group=data
      }
    )
  }

  //#endregion

  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaDevice.xlsx");

  }


}
